const otherBanksList = [
  "DHARMAVIR SAMBHAJI URBAN COOP BANK LTD",
  "THE KARAD URBAN COOP BANK LTD",
  "A G S Office Employees Coop Bank",
  "A P Grameena Vikas Bank",
  "A P Mahajans Coop Urban Bank Ltd",
  "A P Mahesh Coop Urban Bank Ltd",
  "A P Raja Rajeshwari Mahila Coop Bank",
  "AACC Bank",
  "ACE Coop Bank Ltd",
  "ADARNIYA P.D. PATILSAHEB SAHAKARI BANK",
  "ADARSH C0-OPERATIVE BANK LTD",
  "ADCC Bank Ltd",
  "AMRAVATI ZILLA MAHILA SAHAKARI BANK LTD",
  "AMRELI NAGRIK SAHKARI BANK LTD",
  "ANDHRA PRADESH MAHESH",
  "ASSAM GRAMIN VIKASH BANK",
  "ASSOCIATE CO-OP BANK LTD",
  "AUC Bank Ltd",
  "AUCC Bank",
  "Abhinandan Urban Coop Bank Ltd",
  "Abhinvav Sahakari Bank Ltd",
  "Abhyudaya Coop Bank Ltd",
  "Abu Dhabi Commercial Bank Ltd",
  "Adarsh Coop Urban Bank Ltd",
  "Adarsh Mahila Nagari Sahkari Bank Ltd",
  "Adat Farmers Service Coop Bank Ltd",
  "Agra District Coop Bank",
  "Agra Zila Sakakari Bank Ltd",
  "Agrasen Coop Urban Bank Ltd",
  "Agroha Coop Urban Bank Ltd",
  "Ahm Jil Prathamik Shik Sah Bank Ltd",
  "Ahmedabad District Coop Bank Ltd",
  "Ahmednagar Dt Cen Coop Bank Ltd",
  "Ahmednagar Merchants Coop Bank Ltd",
  "Ahmednagar Sahar Sahakari Coop Bank",
  "Air Corporations Employees Coop Bank Ltd",
  "Airtel Payments bank",
  "Ajantha Urban Coop Bank Ltd",
  "Ajinkyatara Mahila Sahakari Bank Ltd",
  "Ajinkyatara Sahakari Bank Ltd",
  "Ajmer Central Coop Bank Ltd",
  "Akathethara Service Coop Bank Ltd",
  "Akhand Anand Coop Bank Ltd",
  "Akola Janata Commercial Cooperative Bank",
  "Akola Janata Coop Bank Ltd",
  "Akola Janta Urban Coop Bank Ltd",
  "Akola Marchant Coop Bank Ltd",
  "Alaknanda Gramin Bank",
  "Alappuzha Govt Servants Coop Bank Ltd",
  "Alappuzha Urban Coop Bank Ltd",
  "Alavi Coop Bank Ltd",
  "Alen Coop Bank Ltd",
  "Alibag Coop Urban Bank Ltd",
  "Aligarh Gramin Bank",
  "Aligarh Zila Sahkari Bank",
  "Allahabad District Coop Bank Ltd",
  "Allahabad Kshetriya Gramin Bank Ltd",
  "Allahabad UP Gramin Bank",
  "Almora Urban Coop Bank Ltd",
  "Almora Zila Sahakari Bank Ltd",
  "Alnavar Urban Coop Bank Ltd",
  "Aloor Service Coop Bank",
  "Aluva Desabhivarthini Service Coop Bank",
  "Alwar Urban Coop Bank Ltd",
  "Aman Sahakari Bank Ltd",
  "Amanath Coop Bank Ltd",
  "Amarambalam Service Coop Bank Ltd",
  "Amarnath Coop Bank Ltd",
  "Ambajogai Peoples Coop Bank Ltd",
  "Ambala Central Coop Bank Ltd",
  "Ambala Kurukshetra Gramin Bank",
  "Ambarnath Jai-Hind Coop Bank Ltd",
  "Ameer Urban Coop Bank Ltd",
  "American Express Bank Ltd",
  "Amlijilla Madhya Sahakari Bank",
  "Ammapet Primary Agriculture Coop Bank",
  "Amritsar Central Coop Bank Ltd",
  "Amruta Mahela Coop Bank",
  "Anand Coop Bank Ltd",
  "Anand Peoples Coop Bank Ltd",
  "Ananda Coop Bank Ltd",
  "Anandeshwari nagrik sahakari bank",
  "Anantapur Coop Town Bank",
  "Anantapur District Central Coop Bank Ltd",
  "Anantha Grameena Bank",
  "Ananthavoor Service Coop Bank",
  "Andaman and Nicobar State Coop Bank Ltd",
  "Andarsul Urban Coop Bank Ltd",
  "Andhra Bank Employees Coop Bank Ltd",
  "Andhra Pradesh Grameena Vikas Bank",
  "Angul United Central Coop Bank Ltd",
  "Anickad Regnl Farmers Service Coop Bank",
  "Anjarakandy Farmers Coop Bank",
  "Ankleshwar Nagrik Sahakari Bank Ltd",
  "Ankleshwar Udhyognagar Coop Bank Ltd",
  "Annasaheb Magar Sahakari Bank",
  "Annasaheb Savant Coop Urban Bank Ltd",
  "Antwerp Diamond Bank",
  "Anuradha Urban Coop Bank Ltd",
  "Anyonya Coop Bank Ltd",
  "Apex Bank Ltd",
  "Apna Sahakari Bank Ltd",
  "Arab Bangladesh Bank",
  "Aranattukara Oriented Coop Bank",
  "Aravali Kshetriya Gramin Bank",
  "Arihant Urban Coop Bank Ltd",
  "Arjun Urban Coop Bank Ltd",
  "Aruna Sahakara Bank Niyamitha",
  "Arvind Sahakari Bank Ltd",
  "Aryavart bank",
  "Aryavart bank",
  "Ashok Sahakari Bank Ltd",
  "Ashoknagar Coop Bank Ltd",
  "Ashta Peoples Coop Bank Ltd",
  "Ashta Urban Coop Bank Ltd",
  "Astha Mahila Nagrik Sah Bank Maryadit",
  "Attingal MunicipalTown Ser Coop Bank Ltd",
  "Aurangabad Dist Ind and Urban Coop Bank",
  "Aurangabad Jilha Madhyavarti Saha Bank",
  "Aurangabad People Coop Bank",
  "Avadh Gramin Bank",
  "Axis Bank Corporate",
  "Ayyanthole Service Coop Bank Ltd",
  "Azad Urban Coop Bank Ltd",
  "B D C C Bank Ltd",
  "B J Khatal Janata Sahakari Bank",
  "B K Mer Coop Bank",
  "B M Gramin Vikas Bank",
  "B M U Coop Bank",
  "B Z R C Mahila Sahakari Bank",
  "BGB",
  "BHEL  Employees Coop Bank Ltd",
  "BMC Bank Ltd",
  "BNP Paribas Bank",
  "BZRC Mahila Sahakari Bank  Niyamit",
  "Babunagar Mahila Coop Bank",
  "Badagabettu Credit Coop Society Ltd",
  "Badagara Coop Rural Bank",
  "Badoda Raj Gramin Bank",
  "Bagalkot Urban Coop Bank Ltd",
  "Baghat Urban Coop Bank Ltd",
  "Baitarini Gramya Bank",
  "Balageria Central Coop Bank Ltd",
  "Balaji Bank",
  "Balangir Anchalik Gramya Bank",
  "Balasinor Nagarik Sahakari Bank Ltd",
  "Balasinor Vikas Coop Credit Soc Ltd",
  "Balasore Bhadrak Central Coop Bank Ltd",
  "Balasore Coop Urban Bank Ltd",
  "Balasore Dist Coop Central Bank Ltd",
  "Balasore Gramya Bank Ltd",
  "Balitikuri Coop Bank Ltd",
  "Ballia Kshetriya Gramin Bank",
  "Bally Coop Bank Ltd",
  "Balotra Urban Coop Bank Ltd",
  "Banaras Mercantile Coop Bank Ltd",
  "Banas Dist Coop Bank Ltd",
  "Banaskanth Dist Mercantile Coop Bank",
  "Banda Dist Coop Bank",
  "Banda Urban Coop Bank Ltd",
  "Bandhan Bank",
  "Bangalore Central Coop Bank",
  "Bangalore City Coop Bank Ltd",
  "Bangalore Dt and Bangalore DCC Bank Ltd",
  "Bangalore Mercantile Coop Bank Ltd",
  "Bangiya Gramin Bikash Bank",
  "Bank International indonesia",
  "Bank of America",
  "Bank of Bahrain and Kuwait",
  "Bank of Baroda - Corporate Banking",
  "Bank of Bhutan",
  "Bank of Ceylon Ltd",
  "Bank of Cochin Ltd",
  "Bank of Goa Ltd",
  "Bank of Muscat International",
  "Bank of Nova Scotia",
  "Bank of Saurashtra",
  "Bank of Tokyo Mitsubishi UFJ Ltd",
  "Banki Central Coop Bank",
  "Bankura Dist Central Coop Bank Ltd",
  "Banque Indosuez",
  "Banque Nationale De Paris",
  "Bapuji Coop Bank Ltd",
  "Bapuji Credit Coop Society Ltd",
  "Barabanki Gramin Bank",
  "Baran Nag Sahkari Bank Ltd",
  "Baranagar Coop Bank Ltd",
  "Barclays Bank PLC",
  "Barclays Bank of Kenya Ltd",
  "Bardhaman Gramin Bank",
  "Bardoli Nagrik Sahakari Bank Ltd",
  "Bareilly Corporation Bank Ltd",
  "Bareilly Kshetriya Gramin Bank",
  "Bareilly Urban Coop Bank Ltd",
  "Baria Nagarik Sahakari Bank Ltd",
  "Barmer Central Co Bank",
  "Baroda City Coop Bank Ltd",
  "Baroda District Indl Coop Bank Ltd",
  "Baroda Gujarat Gramin Bank",
  "Baroda Mercantile Coop Bank Ltd",
  "Baroda People Coop Bank Ltd",
  "Baroda Purvi Gramin Bank",
  "Baroda Rajasthan Kshetriya Gramin Bank",
  "Baroda Traders Coop Bank Ltd",
  "Baroda Uttar Pradesh Gramin Bank",
  "Baroda Western Uttar Pradesh Gramin Bank",
  "Bassein Catholic Co-op Bank",
  "Bastak Khetriya Gramin Bank",
  "Basti Gramin Bank",
  "Bavla Nagrik Sahakari Bank Ltd",
  "Beawar Urban Coop Bank Ltd",
  "Beed District Central Coop Bank Ltd",
  "Begusarai Kshetriya Gramin Bank",
  "Behraampur Coop Central Bank Ltd",
  "Belgaum Pioneer Urban Coop Bank Ltd",
  "Belgaum Urban Credit Souhard Sah Ltd",
  "Belgaum Zil Rani Channamma Mah Saha Bank",
  "Belgum Catholic Coop Bank",
  "Bellad Bagewadi Urb S S Bank Niyamit",
  "Bellary District Coop Central Bank Ltd",
  "Bellary Urban Coop Bank Ltd",
  "Benaras State Bank Ltd",
  "Berhampur Coop Urban Bank Ltd",
  "Betul Nagrika Sahakari Bank",
  "Bhabhar Vibhag Nagrik Sahkari Bank Ltd",
  "Bhadohi Urban Coop Bank Ltd",
  "Bhadradri Coop Urban Bank Ltd",
  "Bhagalpur Central Coop Bank Ltd",
  "Bhagalpur Kshetriya Gramin Bank",
  "Bhagini Nivedita Sahakari Bank Ltd",
  "Bhagirath Gramin Bank",
  "Bhagyalakshmi Mahila Sahakari Bank Ltd",
  "Bhaichand Hirachand Raisoni Saha Pat Ltd",
  "Bhandaaara Gramin Bank",
  "Bhandara District Central Coop Bank Ltd",
  "Bhandara Urban Coop Bank Ltd",
  "Bhandari Coop Bank Ltd",
  "Bharat Coop Bank Ltd",
  "Bharat Mercantile Coop Urban Bank Ltd",
  "Bharat Overseas Bank Ltd",
  "Bharat Sahakari Bank Ltd",
  "Bharat Urban Coop Bank Ltd",
  "Bharati Sahakari Bank Ltd",
  "Bharatpur Central Coop Bank",
  "Bharatpur Urban Coop Bank Ltd",
  "Bhartia Sindhu Coop Society",
  "Bharuch District Central Coop Bank Ltd",
  "Bhatkal Urban Coop Bank Ltd",
  "Bhatpara Naihati Coop Bank Ltd",
  "Bhav Nagarik Sahakari Bank Ltd",
  "Bhavani Sahakari Bank Ltd",
  "Bhavani Urban Coop Bank Ltd",
  "Bhavanikudal Coop Urban Bank Ltd",
  "Bhavnagar Dist Coop Bank Ltd",
  "Bhavnagar Mahila Nag Sah Bank Ltd",
  "Bhilai Nagarik Sahakari Bank Maryadit",
  "Bhilwara Ajmer Kshetriya Gramin Bank",
  "Bhilwara Urban Coop Bank Ltd",
  "Bhimavaram Coop Urban Bank Ltd",
  "Bhingar Urban Coop Bank Ltd",
  "Bhiwani Central Coop Bank Ltd",
  "Bhojpur Rohatash Gramin Bank",
  "Bhopal Coop Central Bank Ltd",
  "Bhopal Nagrik Sahkari Bank",
  "Bhuj Commercial Coop Bank Ltd",
  "Bhuj Mercantile Coop Bank Ltd",
  "Bhupathi Raju Coop Credit Bank Ltd",
  "Bhusawal Peoples Coop Bank Ltd",
  "Bihar Awami Coop Bank",
  "Bihar Kshetriya Gramin Bank",
  "Bijapur Gramin Bank",
  "Bijapur Sahakari Niyamit Bank",
  "Bijnor Urban Coop Bank Ltd",
  "Bikaner Kshetriya Gramin Bank",
  "Bilasa Mahila Nagarik Sahakari Bank",
  "Bilaspur Nagrik Sahakari Bank Ltd",
  "Bilaspur Raipur Kshetriya Gramin Bank",
  "Birbhum District Central Coop Bank Ltd",
  "Birdev Sahakari Bank Ltd",
  "Bodeli Urban Coop Bank Ltd",
  "Bombay Mercantile cooperative bank",
  "Botad Peoples Coop Bank Ltd",
  "Brahmadeo Dada Mane Sahakari Bank Ltd",
  "Brahmawart Commercial Coop Bank Ltd",
  "British Bank of Middle East",
  "Budaun Zila Sahkari Bank Ltd",
  "Buldana Gramin Bank",
  "Buldana Urban Coop Credit Society Ltd",
  "Buldhana District Central Coop Bank Ltd",
  "Bundelkhand Kshetriya Gramin Bank",
  "Bundi Central Coop Bank",
  "Bundi Chittorgarh Kheshetria Gramin Bank",
  "Business Coop Bank Ltd",
  "C D C C Bank",
  "C G Rajya Sahakari Bank Ltd",
  "C K P Coop Bank Ltd",
  "C S Coop Bank",
  "C U CO Bank",
  "CAPITAL LOCAL AREA BANK",
  "CENTRAL MADHYA PRADESH GRAMIN BANK",
  "CHHATTISGARH RAJYA GRAMIN BANK",
  "CNSCB Ltd",
  "CO CO Bank",
  "CO TVCOS Bank",
  "CREDIT SUISSE AG",
  "Cachar Gramin Bank",
  "Calicut City Service Coop Bank Ltd",
  "Calicut North Service Coop Bank",
  "Calyon Bank",
  "Candolim Urban Coop Credit Society Ltd",
  "Capital Bank",
  "Capital Small Bank Finance Ltd",
  "Cardamom Merchant Coop Bank",
  "Cauvery Grameena Bank",
  "Cauvery Kalpatharu Grameena Bank",
  "Caylon Bank Ltd",
  "Central Bank of Commerce",
  "Central Coop Bank Ltd",
  "Century Coop Bank Ltd",
  "Chambal Chetriya Gramin Bank",
  "Chambal Gwalior Kshtriya Gramin Bank",
  "Chamoli Zila Sahakari Bank Ltd",
  "Champaram Khestriya Gramin Bank",
  "Chandgad Urban Coop Bank Ltd",
  "Chandrapur District Central Coop Bank",
  "Chandrapur Gadchiroli Gramin Bank",
  "Channabasavasamy Souharda Pat Sha Bank",
  "Channabasavaswamy Urban Coop Bank",
  "Charminar Coop Urban Bank Ltd",
  "Charotar Nagarik Sahakari Bank Ltd",
  "Chartered Sahakari Bank Niyamitha",
  "Chatrapathi Rajarshi Shahu Ur Coop Bank",
  "Chattisgarh Rajya Sahakari Bank Ltd",
  "Chazhur Service Coop Bank Ltd",
  "Chelannur Service Coop Bank",
  "Chembur Nagarik Sahakari Bank Ltd",
  "Chempazhanthy Service Coop Bank",
  "Chengalai Service Coop Bank",
  "Chennai Central Coop Bank Ltd",
  "Cherathazham Service Coop Bank",
  "Cherthala Service Coop Bank Ltd",
  "Cherukuri MACCS Ltd",
  "Chetana Coop Bank Ltd",
  "Chettallur S Co Bank",
  "Chevayur Service Coop Bank Ltd",
  "Chhapi Nagarik Bank",
  "Chhatrasal Gramin Bank",
  "Chhattisgarh Gramin Bank",
  "Chhattisgarh Rajya Sahakari Bank",
  "Chhindwara Seoni Kshatriya Gramin Bank",
  "Chick Mangalore Kodagu Gramina Bank",
  "Chikmagalur Dist Coop Central Bank Ltd",
  "Chikmagalur Jilla Mahila Sahakara Bank",
  "Chikmaglur Pattana Sahakari Bank",
  "Chinatrust Commercial Bank",
  "Chintamani Nagari Pant Sanstha Ltd",
  "Chiplun Urban Coop Bank Ltd",
  "Chitanvispura Sahakari Bank Ltd",
  "Chitanya Godawari Grameena Bank",
  "Chitnavispura Friends Coop Bank",
  "Chitra Durga Gramina Bank",
  "Chitraduga Dist Coop Central Bank Ltd",
  "Chittoor Kshetiya Bank",
  "Chittorgarh Urban Coop Bank",
  "Chohung Bank",
  "Chopda Peoples Coop Bank Ltd",
  "Chopda Urban Coop Bank Ltd",
  "Choudeshwari Sahakari Bank Ltd",
  "Chungathara Service Coop Bank",
  "Churu Central Coop Bank Ltd",
  "Citizen Co-op Bank Limited",
  "Citizen Coop Bank of India",
  "Citizen Credit Coop Bank Ltd",
  "Citizen Urban CoopBank Ltd",
  "City Union Bank",
  "Cloth Market Coop Bank Ltd",
  "Coastal Bank Ltd",
  "Coastal Local Area Bank Ltd",
  "Coastal Urban Coop Bank Ltd",
  "Coimbatore Dist Central Coop Bank Ltd",
  "Col R D Nikam Sainik Sahakari Bank Ltd",
  "Colour Merchants Coop Bank Ltd",
  "Commercial Co-op Bank Ltd",
  "Commerz Bank AG",
  "Contai Coop Bank Ltd",
  "Coonoor Coop Urban Bank",
  "Cooperative Agricultural Bank Ltd",
  "Cooperative Bank of Ahmedabad",
  "Cooperative Bank of Baroda Ltd",
  "Cooperative Central Bank",
  "Cooperative Mini Bank",
  "Cooperative Urban Bank",
  "Cosmos Bank",
  "Credit Agricole Corp and Inv Bank",
  "Credit Agricole Indosuez",
  "Credit Lyonnais Bank",
  "Cuttack Central Coop Bank",
  "Cuttack Gramya Bank",
  "D K Jilla Mahila Coop Bank",
  "D Y Patil Sahakari Bank Ltd",
  "DEFENCE ACCOUNTS Co-OPERATIVE BANK LTD",
  "DHARMAPURI DISTRICT CENTRAL CO-OP BANK L",
  "DMK Jaoli Bank",
  "DR.BABASAHEB AMBEDKAR URBAN CO-OPERATIVE",
  "Dadasaheb Gajmal Coop Bank Ltd",
  "Dahod Mercantile Coop Bank Ltd",
  "Dahod Urban Coop Bank Ltd",
  "Daivadnya Sahakara Bank Niyamit",
  "Dapoli Urban Coop Bank Ltd",
  "Daund Urban Coop Bank Ltd Daund",
  "Davangere Harihar Urban Coop Bank",
  "Davangere Urban Coop Bank Ltd",
  "Deccan Merchant Co-op Bank Ltd",
  "Deepak Sahakari Bank Ltd",
  "Deesa Nagrik Sahakari Bank Ltd",
  "Delhi Nagrik Sehkari Bank Ltd.",
  "Dena Gujarat Gramin Bank",
  "Deogiri Nagari Sahakari Bank Ltd",
  "Development Credit Bank - Corporate",
  "Devyani Sahakari Bank Ltd",
  "Dhakuria Coop Bank Ltd",
  "Dhanalaxmi Bank - Corporate Net Banking",
  "Dharati Coop Bank Ltd",
  "Dharmapuri Coop Town Bank Ltd",
  "Dhenkanal Gramya Bank",
  "Dhule Vikas Sahakari Bank Ltd",
  "District Central Coop Bank Ltd",
  "District Coop Bank Ltd",
  "Doha Bank",
  "Dombivli Nagari Sahakari Bank Ltd",
  "Dr Ambedkar Nagarik Sahakari Bank",
  "Dr Annasaheb Chougule Urban Co-Op Bank L",
  "Dr Panjabrao Deshmukh Urban Co-op Bk Ltd",
  "Durg Rajnandgaon Gramin Bank",
  "Durgapur Mahila Coop Bank Ltd",
  "Durgapur Steel Peoples Co op Bank Ltd",
  "Dwarkadas Mantri Nagari Sah Bank Ltd",
  "E&N FRONTIER RAILWAY CO-OP BANK LTD",
  "EMIRATES NBD BANK (P.J.S.C)",
  "ESAF SMALL FINANCE BANK",
  "EXCELLENT CO.OP BANK LTD",
  "Edavilangu Service Coop Bank Ltd",
  "Ellaquai Dehati Bank",
  "Eramam Kuttur Service Coop Bank Ltd",
  "Eruvessy Service Coop Bank Ltd",
  "Etah Gramin Bank",
  "Etawah Kshetriya Gramin Bank",
  "Etawah Urban Coop Bank Ltd",
  "FINO PAYMENTS BANK",
  "Farrukhabad Gramin Bank",
  "Fatehpur Dist Coop Bank Ltd",
  "Feroke Coop Urban Bank Ltd",
  "Fincare Small Finance Bank",
  "Fingrowth Cooperative Bank",
  "First Rand Bank Ltd",
  "Friends Coop Bank Ltd",
  "G P R Bank",
  "GP PARSIK Bank",
  "GP Parsik Sahakari Bank Ltd",
  "GS MAHANAGAR COOP BANK LTD",
  "Gadhinglaj Urban Coop Bank Ltd",
  "Gandhibag Sahakari Bank Ltd",
  "Gandhidham Coop Bank Ltd",
  "Gandhinagar Urban Coop Bank Ltd",
  "Ganesh Sahakari Bank Ltd",
  "Ganga Mercantile Urban Coop Bank Ltd",
  "Ganga Yamuna Gramin Bank",
  "Gauhati Coop Urban Bank Ltd",
  "Gautam Sahakari Bank Ltd",
  "Ghaziabad Urban Coop Bank Ltd",
  "Giridih Kshetriya Gramin Bank",
  "Goan Peoples Urban Coop Bank Ltd",
  "Godavari Grameena Bank",
  "Godavari Laxmi Coop Bank Ltd",
  "Godavari Urban Co-op Bank",
  "Godhra City Coop Bank Ltd",
  "Gomti Gramin Bank",
  "Gondal Nagarik Sahakari Bank Ltd",
  "Gooty Coop Town Bank Ltd",
  "Greater Bank",
  "Guardian Souharda Sahakari Bank Niyamita",
  "Gujarat Ambuja Coop Bank Ltd",
  "Gujarat Mercantile Coop Bank Ltd",
  "Gurdaspur Central Coop Bank Ltd",
  "Gurgaon Gramin Bank",
  "Guruvayoor Coop Urban Bank Ltd",
  "Guwahati Coop Urban Bank Ltd",
  "HARYANA GRAMIN BANK",
  "HOOGHLY DISTRICT CENTRAL CO-OPERATIVE BA",
  "HSBC",
  "HUTATMA SAHAKARI BANK LTD",
  "Hadoti Kshetriya Gramin Bank",
  "Hanamasagar Urban Coop Bank Ltd",
  "Hazaribag Kshetriya Gramin Bank",
  "Himachal Pradesh Gramin Bank",
  "Hindustan Coop Bank Ltd",
  "Hisar Sirsa Kshetriya Gramin Bank",
  "Honavar Urban Coop Bank Ltd",
  "Howrah Gramin Bank",
  "Hubli Urban Coop Bank Ltd",
  "ICICI Bank Ltd - Corporate",
  "IDBI Corporate",
  "INDORE PARASPAR SAHAKARI BANK LTD",
  "Ichalkaranji Janata Sahakari Bank Ltd",
  "Ilayangudi Coop Urban Bank Ltd",
  "Imphal Urban Coop Bank Ltd",
  "Indian Mercantile Coop Bank Ltd",
  "Indian Overseas Bank",
  "Indira Mahila Sahakari Bank Ltd",
  "Indore Cloth Market Coop Bank Ltd",
  "Indraprastha Sehkari Bank Ltd",
  "Indrayani Coop Bank Ltd",
  "Industrial Bank Ltd",
  "Innespeta Coop urban Bank Ltd",
  "Integral Urban Co-operative Bank Ltd",
  "Islampur Urban Coop Bank Ltd",
  "J P MORGAN CHASE BANK NA",
  "JAIN CO-OPERATIVE BANK LTD",
  "JALGAON JANATA SAHKARI BANK LTD",
  "JHARKHAND STATE COOP BANK LTD",
  "JHARNESHWAR NAGRIK SAHAKARI BANK MARYDT",
  "JNS Bank Ltd",
  "Jagruti Coop Bank Ltd",
  "Jagruti Coop Urban Bank Ltd",
  "Jai Hind Coop Bank Ltd",
  "Jai Hind Urban Coop Bank Ltd",
  "Jaipur Nagaur Aanchalik Gramin Bank",
  "Jalandhar Central Coop Bank Ltd",
  "Jalaun Dist Coop Bank Ltd",
  "Jalna Gramin Bank",
  "Jalore Central Coop Bank Ltd",
  "Jalore Nagrik Sahakari Bank Ltd",
  "Jalpaiguri Central Coop Bank  Ltd",
  "Jamia Coop Bank Ltd",
  "Jammu Rural Bank",
  "Jamnagar Peoples Coop Bank Ltd",
  "Jamnagar Rajkot Gramin Bank",
  "Jamshedpur Urban Coop Bank Ltd",
  "Jamuna Gramin Bank",
  "Jana Seva Sahakari Bank Ltd",
  "Janakalyan Coop Bank Ltd",
  "Janakalyan Sahakari Bank Ltd",
  "Janata Coop Bank Ltd",
  "Janata Sahakari Bank Ltd",
  "Jangipur Urban Coop Credit Society Ltd",
  "Janseva Coop Bank Ltd",
  "Janseva Sahakari Bank Ltd",
  "Jansewa Urban Coop Bank Ltd",
  "Jaysingpur Udgaon Sahakari Bank Ltd",
  "Jhabua Dhar Kshetriya Gramin Bank",
  "Jhalawar Kendriya Sahakari Bank Ltd",
  "Jharkhand Gramin Bank",
  "Jharkhand Rajya Gramin Bank",
  "Jijamata Mahila Nagari Sahakari Bank Ltd",
  "Jijamata Mahila Urban Coop Bank Ltd",
  "Jijau Commercial Coop Bank Ltd",
  "Jila Sahakari Bank Ltd",
  "Jilla Sahakari Kendriya Bank Maryadit",
  "Jivaji Sahakari Bank Ltd",
  "Jivan Commercial Co op bank Ltd",
  "Jodhpur Central Coop Bank Ltd",
  "Jodhpur Nagrik Sahakari Bank Ltd",
  "Junagadh Commercial Coop Bank Ltd",
  "Junagadh Jilla Sahakari Bank Ltd",
  "KESHAV SEHKARI BANK LTD.",
  "KHALILABAD NAGAR SAHKARI BANK LTD",
  "KOKAN MERCANTILE CO-OP BANK LTD",
  "KOLHAPUR DISTRICT CENTRAL CO-OP BANK LTD",
  "KONOKLOTA MAHILA URBAN COOP BANK LTD",
  "KOZHIKODE DISTRICT CO OP BANK",
  "Kadampanad Service Coop Bank Ltd",
  "Kadannamanna Service Coop Bank Ltd",
  "Kadi Nagarik Sahakari Bank Ltd",
  "Kalady Farmers Coop Bank Ltd",
  "Kalahandi Anchalika Gramya Bank",
  "Kalinga Gramya Bank",
  "Kallamkunnu Service Coop Bank Ltd",
  "Kallappanna Awade Ichalkaranji Janata",
  "Kallettumkara Service Coop Bank",
  "Kalol Urban Coop Bank Ltd",
  "Kalupur Commercial Coop Bank Ltd",
  "Kalyan Janata Sahakari Bank",
  "Kalyan Janata Sahakari Bank",
  "Kanaka Mahalakshmi Coop Bank Ltd",
  "Kanakadurga Grameena Bank",
  "Kanakkary Service Coop Bank Ltd",
  "Kancheepuram Central Coop Bank Ltd",
  "Kancheepuram Coop Town Bank Ltd",
  "Kankaria Maninagar Nagrik Sahakari Bank",
  "Kannur Dist Coop Bank Ltd",
  "Kapurthala Central Coop Bank Ltd",
  "Karavali Credit Coop Society Ltd",
  "Karmala Urban Coop Bank",
  "Karnala Nagari Sahakari Bank Ltd",
  "Karnataka State Coop Apex Bank Ltd",
  "Karnataka Vikas Grameena Bank",
  "Karnavati Coop Bank Ltd",
  "Karur Vysya Bank",
  "Karwar Urban Coop Bank Ltd",
  "Kasaragod Service Coop Bank Ltd",
  "Kashi Gomti Samyut Gramin Bank",
  "Kashi Gramin Bank",
  "Kashmir Mercantile Nagar Sahkari Bank Lt",
  "Kasundia Coop Bank Ltd",
  "Kaveri Grameena Bank",
  "Kavita Urban Coop Bank Ltd",
  "Kedarnath Urban Coop Bank Ltd",
  "Kerala Gramin Bank",
  "Kerala Mercantile Coop Bank Ltd",
  "Kerala State Coop Bank Ltd",
  "Kodagu Dist Coop Central Bank Ltd",
  "Kodaikanal Coop Urban Bank Ltd",
  "Kodoli Urban Coop Bank",
  "Kolar Gramin Bank",
  "Kolhapur Mahila Sahakari Bank Ltd",
  "Kolhapur Urban Coop Bank Ltd",
  "Konkan Prant Sahakari Bank Ltd",
  "Konnagar Samabaya Bank Ltd",
  "Koovappady Service Coop Bank Ltd",
  "Kopargaon Peoples Coop Bank Ltd",
  "Kota Central Coop Bank Ltd",
  "Koteshwara Sahakari Bank Niyamitha",
  "Kothamangalam Service Coop Bank Ltd",
  "Kottakkal Coop Urban Bank Ltd",
  "Kottapadi Service Coop Bank Ltd",
  "Kottayam Coop Urban Bank Ltd",
  "Kottayam Dist  Coop Bank Ltd",
  "Kovilpatti Coop Urban Bank Ltd",
  "Krishna Grameena Bank",
  "Krishna Mercantile Coop Bank Ltd",
  "Krishnagar City Coop Bank Ltd",
  "Kulasekharapuram Service Coop Bank Ltd",
  "Kumarakom Service Coop Bank Ltd",
  "Kumaranalloor Service Coop Bank Ltd",
  "Kumbhi Kasari Sahakari Bank Ltd",
  "Kunbi Sahakari Bank Ltd",
  "Kuppam Coop Town Bank Ltd",
  "Kurichy Service Coop Bank Ltd",
  "Kurla Nagarik Sahakari Bank Ltd",
  "Kurmanchal Nagar Sahakari Bank Ltd",
  "Kuruppampady Service Coop Bank",
  "Kutch Corporative Bank",
  "Kuzhuppilly Service Coop Bank Ltd",
  "Kuzhur Service Coop Bank Ltd",
  "LALA URBAN CO-OP BANK LTD",
  "LATUR URBAN CO-OP BANK LTD",
  "LAXMIBAL MAHILA NAGRIK SAHAKARI BANK MAR",
  "LILUAH CO OPERATIVE BANK LTD",
  "LOKMANGAL",
  "LOKVIKAS NAGARI SAHAKARI BANK LTD",
  "Lalbaug Coop Bank Ltd",
  "Langpi Dehangi Rural Bank",
  "Latur District Central Co-op Bank Ltd",
  "Laxmi Sahakari Bank Niyamit",
  "Laxmi Urban Coop Bank Ltd",
  "Lila Sahkari Bank Ltd",
  "Liluah Coop Bank Ltd",
  "Limbasi Urban Coop Bank Ltd",
  "Limdi Urban Coop Bank Ltd",
  "Lloyds Bank",
  "Lokamaleswaram Service Coop Bank",
  "Lokmangal Coop Bank Ltd",
  "Lokmangal Urban Coop Bank Ltd",
  "Lokmanya Coop Credit Society  Ltd",
  "Lonavala Sahakari Bank Ltd",
  "Lonavala Sahakari Bank Maryadit",
  "Lucknow Urban Coop Bank Ltd",
  "M G B Gramin Bank",
  "M. S. Co-Operative Bank Limited",
  "M.D Pawar People's Co-operative Bank Itd",
  "MADHESHWARI URBAN DEVELOPMENT CO-OP BANK",
  "MADHYA PRADESH GRAMIN BANK",
  "MADHYANCHAL GRAMIN BANK",
  "MAKARPURA INDUSTRIAL EST CO.OP BANK Ltd",
  "MALVIYA URBAN CO-OPERATIVE BANK Ltd.",
  "MEGHALAYA RURAL BANK",
  "MURSHIDABAD DIST CENTRAL CO-OP BANK LTD",
  "Madai Coop Rural Bank Ltd",
  "Madgaum Urban Coop Bank Ltd",
  "Madhav Nagarik Sahakari Bank Ltd",
  "Madhubani Kshetriya Gramin Bank",
  "Madhya Bharat Gramin Bank",
  "Madhya Bihar Gramin Bank",
  "Madras Central Coop Bank Ltd",
  "Magadh Gramin Bank",
  "Maha Kaushal Kshetriya Gramin Bank",
  "Mahalaxmi Urban Coop Credit Bank",
  "Mahamedha Urban Coop Bank Ltd",
  "Mahanagar Coop Bank Ltd",
  "Mahanagar Nagrik Sahakari Bank Maryadit",
  "Mahanagar State Coop Bank Ltd",
  "Maharashtra Godavari Gramin Bank",
  "Maharashtra Gramin Bank",
  "Maharashtra Mantralaya&Allied Coop Bank",
  "Mahesana Samaj Coop Bank Ltd",
  "Mahesh Sahakari Bank Limited",
  "Mahesh Urban Coop Bank Ltd",
  "Mahila Urban Coop Bank Ltd",
  "Mahila co-op Nagarik Bank Ltd",
  "Mahishmati Nagrik Sahakari Bank Ltd",
  "Makarpura Ind Estate Coop Bank Ltd",
  "Malad Sahakari Bank Ltd",
  "Malappuram Service Coop Bank Ltd",
  "Malaprabha Grameena Bank",
  "Malegaon Merchants Coop Bank Ltd",
  "Mallabhum Gramin Bank",
  "Malleswaram Coop Bank Ltd",
  "Malwa Gramin Bank",
  "Mandvi Coop Bank Ltd",
  "Mangal Coop Bank Ltd",
  "Mangala Credit Coop Society Ltd",
  "Maninagar Coop Bank Ltd",
  "Manipal Coop Bank Ltd",
  "Manipur Rural Bank",
  "Manjeri Service Coop Bank Ltd",
  "Mankada Service Coop Bank Ltd",
  "Manorama Urban Coop Bank Ltd",
  "Mansingh Coop Bank Ltd",
  "Manwat  Urban Coop Bank Ltd",
  "Maradu Service Coop Bank Ltd",
  "Maratha Coop Urban Bank Ltd",
  "Maratha Sahakari Bank Ltd",
  "Marketyard Commercial Coop Bank Ltd",
  "Mathura Zila Sahkari Bank Ltd",
  "Mavoor Service Coop Bank Ltd",
  "Mayurakshi Gramin Bank",
  "Meghalaya Coop Apex Bank Ltd",
  "Mehsana District Central Coop Bank Ltd",
  "Mehsana Urban Coop Bank Ltd",
  "Merchants Coop Bank Ltd",
  "Merchants Liberal Coop Bank Ltd",
  "Merchants Urban Coop Bank Ltd",
  "Methala Service Coop Bank Ltd",
  "Mewar Aanchalik Gramin Bank",
  "Midnapore Peoples Coop Bank Ltd",
  "Millath Coop Bank Ltd",
  "Mithila Kshetriya Gramin Bank",
  "Mizoram Co Oper Apex Bank Ltd",
  "Mizoram Rural Bank",
  "Mizoram Urban Co Op Developmnt Bank Ltd",
  "Model Coop Bank Ltd",
  "Mogaveera Coop Bank Ltd",
  "Mohanur Coop Bank Ltd",
  "Moospet Service Coop Bank Ltd",
  "Mowanchery Coop Rural Bank Ltd",
  "Muktai Coop Bank Ltd",
  "Mulakulam Service Coop Bank Ltd",
  "Mumbai District Central Cooperative Bank",
  "Mundaje Coop Agricultural Bank Ltd",
  "Murshidabad Gramin Bank",
  "Muslim Coop Bank Ltd",
  "Mysore Merchants Coop Bank Ltd",
  "NADIA DISTRICT CENTRAL CO-OP BANK LTD",
  "NAGAR SAHAKARI BANK LTD GORAKHPUR",
  "NAGRIK SAHAKARI BANK MARYADHIT VIDISHA",
  "NAINTAL DIST COOP BANK LTD",
  "NARMADA JHABUA GRAMIN BANK",
  "NAVI MUMBAI CO-OP.BANK LTD",
  "NKGSB Bank",
  "NKGSB Co op Bank Ltd",
  "NOBLE CO OP BANK LTD",
  "Naadt Central Coop Bank Ltd",
  "Nabadwip Coop Credit Bank Ltd",
  "Nabagram Peoples Coop Credit Bank Ltd",
  "Nadakkal Service Coop Bank",
  "Nadakkuthazha Service Coop Bank Ltd",
  "Nadia Gramin Bank",
  "Nagar Vikas Sahkari Bank Ltd",
  "Nagarik Sahakari Bank Ltd",
  "Nagarik Samabay Bank Ltd",
  "Nagpur Mahanagarpalika Karmachari",
  "Nagpur Nagarik Sahakari Bank Ltd",
  "Nagpur Urban Coop Bank Ltd",
  "Nagrik Sahakari Bank Maryadit Gwalior",
  "Nainital Almora Kshetriya Gramin Bank",
  "Nalanda Gramin Bank",
  "Namakkal Coop Urban Bank Ltd",
  "Nandani Sahakari Bank Ltd",
  "Nanded Merchant Coop Bank Ltd",
  "Nandura Urban Coop Bank Ltd",
  "Narayanaguru Urban Coop Bank Ltd",
  "Naroda Nagrik Coop Bank Ltd",
  "Nashik Dist Girana Coop Bank Ltd",
  "Nasik District Central Coop Bank Ltd",
  "Nasik Jilha Mahila Sahakari Bank Ltd",
  "National Bank of Dubai",
  "National Mercantile Coop Bank Ltd",
  "National Urban Co-op Bank Ltd",
  "Nattika Firka Coop Rural Bank Ltd",
  "Navabharat Coop Urban Bank Ltd",
  "Naval Dockyard Coop Bank Ltd",
  "Navi Mumbai Nagari Sahakari Bank Ltd",
  "Navnirman Coop Bank Ltd",
  "Navodaya Urban Coop Bank Ltd",
  "Navsarjan Industrial Coop Bank Ltd",
  "Nedungadi Bank Ltd",
  "Needs of Life Coop Bank Ltd",
  "Neelachal Gramya Bank",
  "Nellai Nagar Coop Urban Bank Ltd",
  "Nellore District Coop Central Bank Ltd",
  "Netravati Grameena Bank",
  "New Bank of India",
  "New India Coop Bank Ltd",
  "Nidhi Coop Bank Ltd",
  "Nilambur Coop Urban Bank Ltd",
  "Niphad Urban Coop Bank Ltd",
  "Nirmal Urban Coop Bank Ltd",
  "Nishigandha Sahakari Bank Ltd",
  "Noida Commercial Coop Bank Ltd",
  "North East Small  Finance Bank",
  "North Malabar Gramin Bank",
  "Nova Scotia Bank",
  "Nutan Nagarik Sahakari Bank Ltd",
  "OMPRAKASH DEORA PEOPLES CO OP BANK LTD",
  "Odisha Gramya Bank",
  "Orissa State Coop Bank Ltd",
  "Osmanabad Janata Sahakari BAnk Ltd.",
  "P I J Peoples Coop Bank",
  "PANCHGANGA BANK",
  "PARSHWANATH CO-OP BANK LTD",
  "PATHANMTHITTA DISTRICT CO OP BANK LTD",
  "PAYTM PAYMENTS BANK LTD",
  "PEOPLE'S CO-OP BANK LTD, DHOLKA",
  "PIMPRI-CHINCHWAD SAHAKARI BANK MARYADIT",
  "Padmavathi Coop Urban Bank Ltd",
  "Pala Urban Coop Bank Ltd",
  "Palakkad Service Coop Bank Ltd",
  "Palani Coop Urban Bank Ltd",
  "Pali Urban Coop Bank Ltd",
  "Palus Sahakari Bank Ltd",
  "Panayal  Service Coop Bank Ltd",
  "Panch Mahal Vadodara Gramin Bank",
  "Panchkula Urban Coop Bank Ltd",
  "Pandyan Grama Bank",
  "Pang Service Coop Bank Ltd",
  "Panipat Central Coop Bank Ltd",
  "Panmana Service Coop Bank Ltd",
  "Papanasam Coop Urban Bank Ltd",
  "Parappur Service Coop Bank Ltd",
  "Parivartan Coop Bank Ltd",
  "Parner Taluka Sainik Sahakari Bank Ltd",
  "Parsik Janata Sahakari Bank Ltd",
  "Parvatiya Gramin Bank",
  "Parwanoo Urban Coop Bank Ltd",
  "Paschim Banga Gramin Bank",
  "Patan Coop Bank Ltd",
  "Patan Nagarik Sahakari Bank Ltd",
  "Patan Urban Coop Bank Ltd",
  "Pathankot Hindu Urban Coop Bank Ltd",
  "Patiala Central Coop Bank Ltd",
  "Patliputra Central Coop Bank Ltd",
  "Patni Coop Bank Ltd",
  "Pattathanam Service Coop Bank Ltd",
  "Pavana Sahakari Bank Ltd",
  "Payyanur Coop Town Bank Ltd",
  "Payyanur Service Coop Bank Ltd",
  "Peoples Co Op Bank Ltd,Hingoli",
  "Perinthalmanna Coop Urban Bank Ltd",
  "Periyakulam Coop Urban Bank Ltd",
  "Perumatty Service Coop Bank",
  "Pimpri Chinchwad Sahakari Bank Maryadit",
  "Pinakini Grameena Bank",
  "Pithoragarh Kshetriya Gramin Bank",
  "Pithoragarh Zila Sahkari Bank Ltd",
  "Pollachi Coop Urban Bank Ltd",
  "Pondicherry Coop Urban Bank Ltd",
  "Pondicherry State Coop Bank Ltd",
  "Poornawadi Nagarik Sahakari Bank M Beed",
  "Pragathi Krishna Gramin Bank",
  "Pragati Sahakari Bank Ltd",
  "Pratap Coop Bank Ltd",
  "Prathama Bank",
  "Pravara Sahakari Bank Ltd",
  "Premier Auto Emp Coop Bank Ltd",
  "Prerana Coop Bank Ltd",
  "Prime Coop Bank Ltd",
  "Pritisangam Sahakari Bank Ltd",
  "Priyadarshani Nagari Sahakari Bank Ltd",
  "Priyadarshani Urban Coop Bank Ltd",
  "Progressive Coop Bank Ltd",
  "Progressive Mercantile Coop Bank Ltd",
  "Progressive Urban Coop Bank Ltd",
  "Prudential Coop Bank Ltd",
  "Prudential Coop Urban Bank Ltd",
  "Pudukkottai Dist Central Coop Bank Ltd",
  "Puduvai Bharathiar Grama Bank",
  "Pune Cantonment Sahakari Bank Ltd",
  "Pune District Central Co-op Bank Ltd",
  "Pune Merchants Coop Bank Ltd",
  "Pune People's Co-op Bank Ltd",
  "Pune Sahakari Bank Ltd",
  "Pune Urban Cooperative Bank Limited",
  "Punjab Coop Bank Ltd",
  "Punjab Gramin Bank",
  "Punjab National Bank - Corporate Banking",
  "Punjab State Coop Bank Ltd",
  "Punnol Service Coop Bank Ltd",
  "Puri Gramya Bank",
  "Purulia Central Coop Bank Ltd",
  "Purvanchal Bank",
  "Puthenchira Service Coop Bank",
  "Puttur Coop Town Bank Ltd",
  "Quilon Coop Urban Bank Ltd",
  "RAIGANJ CENTRAL CO-OPERATIVE BANK LTD",
  "RAJADHANI COOP BANK LTD",
  "RAMPUR ZILA SAHKARI BANK LTD",
  "RCC Bank",
  "RENDAL SAHAKARI BANK LTD",
  "Radhasoami Urban Coop Bank Ltd",
  "Raebareli Kshetriya Gramin Bank",
  "Raghuvanshi Coop Bank Ltd",
  "Raigad Sahakari Bank Ltd",
  "Raigarh Kshetriya Gramin Bank",
  "Railway Employees Coop Bank Ltd",
  "Raj Laxmi Mahila Urban Coop Bank Ltd",
  "Rajajinagar Coop Bank Ltd",
  "Rajapalayam Coop Urban Bank Ltd",
  "Rajapur Sahakari Bank Ltd",
  "Rajarambapu Sahakari Bank Ltd",
  "Rajarshi Sahu Govt Servant Coop Bank Ltd",
  "Rajarshi Shahu Sahakari Bank Ltd",
  "Rajasthan Gramin Bank",
  "Rajasthan Marudhara Gramin Bank",
  "Rajasthan State coop Bank",
  "Rajdhani Nagar Sahkari Bank Ltd",
  "Rajguru Nagar Sahakari Bank Ltd",
  "Rajkot Nagarik Sahakari Bank Ltd",
  "Rajkot Peoples Co. Op. Bank Ltd",
  "Rajlaxmi Urban Coop Bank Ltd",
  "Rajputana Mahila Urban Coop Bank",
  "Rajsamand Urban Coop Bank Ltd",
  "Rajula Nagarik Sahakari Bank Ltd",
  "Ramanathapuram Coop Urban Bank Ltd",
  "Rameshwar Coop Bank Ltd",
  "Ramgarhia Co-Operative Bank Ltd.",
  "Ramkrishnapur Coop Bank Ltd",
  "Rampur Zila Sahkari Bank Ltd.",
  "Ranchi Kshetriya Gramin Bank",
  "Raniganj Coop Bank Ltd",
  "Ranilakshmibai Kshetriya Gramin Bank",
  "Ranilaxmibai Urban Coop Bank Ltd",
  "Ratanchand Shah Sahakari Bank Ltd",
  "Ratnagiri Dist Central coop Bank Ltd",
  "Ratnakar Corporate Banking",
  "Ravi Commercial Urban Coop Bank Ltd",
  "Rayalaseema Grameena Bank",
  "Rayat Sevak Coop Bank Ltd",
  "Repco Bank Ltd",
  "Reserve Bank of India",
  "Revdanda Coop Urban Bank Ltd",
  "Ropar Central Coop Bank Ltd",
  "Royal Bank of Canada",
  "Rukmini Sahakari Bank Ltd",
  "Rushikulya Gramya Bank",
  "S S L S A KURUNDWAD URBAN BANK LTD",
  "SANMITRA MAHILA NAGARI SAHAKARI BANK MYD",
  "SARDAR BHILADWALA PARDI PEOPL COOP BANK",
  "SARDAR BHILADWALA PARDI PEOPLE'S CO-OP",
  "SARVA HARYANA GRAMIN BANK",
  "SARVA UP GRAMIN BANK",
  "SAWAI MADHOPUR URBAN CO OP BANK LTD",
  "SDCC Bank Ltd",
  "SHANKAR NAGARI SAHAKARI BANK LTD.",
  "SHINHAN BANK",
  "SHIVAJI NAGARI SAHAKARI BANK LTD",
  "SHREE BALAJI URBAN COOPERATIVE BANK",
  "SHREE DHARATI CO-OP BANK LTD",
  "SHREE GAJANAN LOKSEVA SAHAKARI BANK",
  "SHREE MAHALAXMI MERCANTILE CO-OP BANK LT",
  "SHREE MAHESH CO-OP BANK LTD",
  "SHREE SHARADA SAHAKARI BANK",
  "SHREEJI BHATIA CO-OPERATIVE BANK LTD",
  "SHRI ANAND NAGARI SAHAKARI BANK LTD",
  "SHRI ARIHANT CO-OP BANK LTD",
  "SHRI CHHANI NAGRIK SAHAKARI BANK LTD",
  "SHRI CHHATRAPATI RAJARSHI SHAHU URBAN CO",
  "SHRI KANYAKA NAGARI SAHAKARI BANK LTD",
  "SHRI MAHALAXMI CO-OP BANK LTD",
  "SHRI MAHAVIR URBAN CO-OP BANK LTD",
  "SHRI VEERSHAIV CO-OP.BANK LTD",
  "SHRI YASHWANT SAHAKARI BANK MARYADIT",
  "SHRIKRISHNA CO OP BANK Ltd.",
  "SHUSHRUTI SOUHARDA SAHAKARA BANK NIYAMIT",
  "SIK",
  "SONALI BANK LIMITED",
  "SREE CHARAN BANK",
  "SRI KANYAKAPARAMESWARI CO OPERATIVE BANK",
  "SRI POTTI SRIRAMULU NELLORE DCCB",
  "SUMERPUR MERCANTLE URBAN CO-OP BANK LTD",
  "SURATH NATIONAL CO-OPERATIVE BANK LTD",
  "SVC Co-operative Bank Ltd",
  "Sachin Industrial Coop Bank Ltd",
  "Sadguru Gahininath Urban Coop Bank Ltd",
  "Sadhana Sahakari Bank Ltd",
  "Safe Coop Bank Ltd",
  "Sagar Gramin Bank",
  "Sahebrao Deshmukh Coop Bank Ltd",
  "Sahyog Coop Bank Ltd",
  "Sai Coop Urban Bank Ltd",
  "Saidapet Coop Bank Ltd",
  "Sainik Sahakari Bank Ltd",
  "Sakura Bank Ltd",
  "Salem Urban Coop Bank Ltd",
  "Samarth Sahakari Bank Ltd",
  "Samarth Urban Coop Credit Society Ltd",
  "Samasta Nagar Coop Bank Ltd",
  "Samata Coop Development Bank Ltd",
  "Samata Sahakari Bank Ltd",
  "Sampada Sahakari Bank Ltd",
  "Samruddhi Coop Bank Ltd",
  "Sangameshwara Grameena Bank",
  "Sangli District Central Coop Bank Ltd",
  "Sangli Sahakari Bank Ltd",
  "Sangli Urban Coop Bank Ltd",
  "Sankari Coop Urban Bank Ltd",
  "Sankhali Urban Coop Credit Society Ltd",
  "Sankheda Nagarik Sahakari Bank Ltd",
  "Sanmitra Sahakari Bank Ltd",
  "Sant Sopankaka Sahakari Bank Limited",
  "Santhal Parganas Gramin Bank",
  "Sanwa Bank Ltd",
  "Saptagiri Grameena Bank",
  "Saran Kshetriya Gramin Bank",
  "Sarangpur Coop Bank Ltd",
  "Saraspur Nagrik Coop Bank Ltd",
  "Saraswat Bank",
  "Sardar Vallabhbhai Sahakari Bank Ltd",
  "Sarvodaya Commercial Co-op Bank Ltd.",
  "Satara Dist Central cooperative bank Ltd",
  "Satara Sahakari Bank Ltd",
  "Sathyamangalam  Coop Urban Bank Ltd",
  "Satya Shodhak Sahakari Bank Ltd",
  "Saurashtra Coop Bank Ltd",
  "Saurashtra Gramin Bank",
  "Savanur Urban Coop Bank Ltd",
  "Sawai Madhopur Kendriya Sahkari Bank Ltd",
  "Scotia Bank",
  "Sevalia Urban Coop Bank Ltd",
  "Seven Hills Coop Urban Bank Ltd",
  "Shahjahanpur Kshetriya Gramin Bank",
  "Shalini Sahakari Bank Ltd",
  "Shamrao Vithal Bank Corporate",
  "Sharad Sahakari Bank Ltd",
  "Sharada Sahakari Bank Ltd",
  "Shekhawati Gramin Bank",
  "Sher Nagrik Sahakari Bank Ltd",
  "Shiggaon Urban Coop Bank Ltd",
  "Shikshak Sahakari Bank Ltd",
  "Shinhan Bank",
  "Shiva Sahakari Bank Niyamita",
  "Shivajirao Bhosale Sahakari Bank Ltd",
  "Shivalik Kshetriya Gramin Bank",
  "Shivalik Mercantile Coop Bank Ltd",
  "Shivalik Small Finance Bank",
  "Shivneri Sahakari Bank Ltd",
  "Shivpuri Guna Kshetriya Gramin Bank",
  "Shree Adinath Co Op Bank Ltd",
  "Shree Adinath Sahakari Bank Ltd",
  "Shree Bhavnagar Nagrik Sahakari Bank Ltd",
  "Shree Cooperative Bank Limited",
  "Shree Gajanan Lokseva Sahakari Bk Maryad",
  "Shree Gajanan Urban Coop Bank Ltd",
  "Shree Kadi Nagarik Shakari Bank Ltd",
  "Shree Laxmi Co-op Bank Limited",
  "Shree Mahavir Sahakari Bank ltd",
  "Shree Mahesh Sahakari Bank Ltd",
  "Shree Mahuva Nagrik Sahakari Bank Ltd",
  "Shree Panchganga Nagri Sahakari Bank Ltd",
  "Shree Samarth Sahakari Bank Ltd",
  "Shree Warana Sahakari Bank Ltd",
  "Shreyas Coop Bank Ltd",
  "Shreyas Gramin Bank",
  "Shri Arihant Coop Bank Ltd",
  "Shri Balbhim Coop Bank Ltd",
  "Shri Laxmikrupa Urban Coop Bank Ltd",
  "Shri Mahalaxmi Co-op. Bank Ltd",
  "Shri Mahila Sewa Sahakari Bank Ltd",
  "Shri Rajkot Dist. Co. Op. Bank",
  "Shri Satyavijay Sahakari Bank Ltd",
  "Shri Vijay Mahantesh Coop Bank Ltd",
  "Shrimant Malojiraje Sahakari Bank Ltd",
  "Shripatraodada Sahakari Bank Ltd",
  "Shriram Urban Coop Bank Ltd",
  "Siddharth Sahakari Bank Ltd",
  "Siddheshwar Sahakari Bank Ltd",
  "Siddhi Coop Bank Ltd",
  "Sihor Mercantile Coop Bank Ltd",
  "Sikar Urban Coop Bank Ltd",
  "Sind Bank",
  "Sindhanur Urban Coop Bank Ltd",
  "Sindhudurg Sahakari Bank Ltd",
  "Sir M Visvesvaraya Coop Bank Ltd",
  "Sirohi Central Coop Bank Ltd",
  "Siwan Kshetriya Gramin Bank",
  "Societe Generale Bank",
  "Solapur Janata Sahakari Bank Ltd",
  "Sonepat Central Coop Bank Ltd",
  "Sopankaka Sahakari Bank Ltd",
  "South Indian Coop Bank Ltd",
  "Sree Coop Urban Bank Ltd",
  "Sree Kandamangalam Service Coop Bank Ltd",
  "Sreenidhi Sahakara Bank Niyamitha",
  "Sri Kanaka Credit Coop Society Ltd",
  "Sri Lakshminarayana Coop Bank Ltd",
  "Srimatha Mahila Sahakari Bank Niyamitha",
  "Standard Urban Co Op Bank(Aurangabad Ltd",
  "State Bank of Mauritius Ltd",
  "State Transport Coop Bank Ltd",
  "Sterling Urban Coop Bank Ltd",
  "Subhadra Local Area Bank Ltd",
  "Suco Souharda Sahakari Bank",
  "Sulaimani Coop Bank Ltd",
  "Sundarlal Sawji Urban Co-op Bank Ltd",
  "Surat Bharuch Gramin Bank",
  "Surat Mercantile Coop Bank Ltd",
  "Surat Textile Traders Co Operative Bank",
  "Surendranagar Bhavnagar Gramin Bank",
  "Sushilkumar Nahata Urban Coop Bank Ltd",
  "Sutex Bank",
  "Sutlej Gramin Bank",
  "Suvarna Coop Bank Ltd",
  "Suvarna Coop Credit Society Ltd",
  "Suvarnayug Sahakari Bank Ltd",
  "Swami Narayan Coop Bank Ltd",
  "Swami Samarth Sahakari Bank Ltd",
  "Swaraj Urban Coop Bank Ltd",
  "Swarna Coop Urban Bank Ltd",
  "TEHRI GARHWAL ZILA SAHKARI BANK LTD",
  "THE AKOLA JANATA COMM. COOP BANK LTD",
  "THE ANAND MERCANTILE CO-OPERATIVE BANK L",
  "THE ANDHRA PRADESH STATE CO-OP BANK LTD",
  "THE AP MAHESH CO-OP URBAN BANK LTD",
  "THE ASSAM CO-OPERATIVE APEX BANK LIMITED",
  "THE BABASAHEB DESHMUKH SAHAKARI BANK LTD",
  "THE BARODA CITY CO-OPERATIVE BANK LTD",
  "THE BHARATH CO OP BANK LTD",
  "THE BICHOLIM URBAN CO-OPERATIVE BANK LTD",
  "THE BIJAPUR MAHALAXMI URBAN CO-OPERATIVE",
  "THE BURDWAN CENTRAL CO OP BANK LTD",
  "THE CHANASMA NAGRIK SAHAKARI BANK LID",
  "THE CHANDIGARH STARE COOP BANK LTD",
  "THE CHIKHLI URBAN CO-OP.BANK.LTD",
  "THE CHITTOOR DIST CO OP CENTRAL BANK LTD",
  "THE COMMERCIAL CO-OP BANK LTD",
  "THE DELHI STATE CO- OPERATIVE BANK LTD",
  "THE DHANERA MERCANTILE CO OP BANK LTD",
  "THE DIST CENTRAL CO OP BANK LTD ELLURU",
  "THE DIST CO OP BANK LTD VIZIANAGARAM",
  "THE DIST CO OP CENTRAL BANK LTD KAKINADA",
  "THE DIST CO OP CENTRAL BANK LTD KURNOOL",
  "THE DIST CO OP CENTRAL BANK LTD SRIKAKUL",
  "THE DIST CO OP CNTRL BANK LTD VIZAG",
  "THE EENADU COOP  URBAN BANK LTD",
  "THE GADCHIROLI DIST CENTL COOP BANK LTD",
  "THE GANDHIDHAM MERCANTILE CO-OP BANK LTD",
  "THE GANDHINAGAR NAGARIK CO-OP BANK LTD",
  "THE GAUHATI CO-OPERATIVE URBAN BANK LTD",
  "THE GUNTUR DIST CO OP CENTRAL BANK LTD",
  "THE HANUMANTHANAGAR CO-OP.BANK LTD",
  "THE INCOME TAX DEPT CO OP BANK LTD MUMBA",
  "THE INDUSTRIAL CO-OPERATIVE BANK LTD",
  "THE JALNA PEOPLES COOP BANK LTD",
  "THE KADAPPA DIST CO OP CENTRAL BANK LTD",
  "THE KAIRA DISTRICT CENTRAL CO OP BANK LT",
  "THE KARAD URBAN CO-OP BANK LTD",
  "THE KARAN URBAN COOP BANK LTD",
  "THE KOYLANCHAL URBAN CO-OPERATIVE BANK L",
  "THE KRISHNA DISTRICT CO OP BANK",
  "THE KURLA NAGARIK SAHAKARI BANK LTD",
  "THE MANMANDIR CO-OP. BANK LTD",
  "THE MEHSANA URBAN CO-OP BANK LTD",
  "THE MOGA CENTRAL COOPERATIVE BANK LTD",
  "THE MUGBERIA CENTRAL COOPERATIVE BANK LT",
  "THE MUSLIM CO-OP BANK LTD",
  "THE NABADWIP CO-OPERATIVE CREDIT BANK LT",
  "THE NAINITAL BANK LTD",
  "THE NARAKAL SERVICE CO-OPERATIVE BANK LT",
  "THE NASIK ROAD DEOLALI VYAPARI SAHAKARI",
  "THE NAV JEEVAN COOP BANK LTD",
  "THE NAWANAGAR CO-OPERATIVE BANK LTD",
  "THE NILGIRIS DISTRICT CENTRAL CO OP BANK",
  "THE PANCHSHEEL MERCANTILE COOP. BANK LTD",
  "THE PANVEL CO-OPERATIVE URBAN BANK LTD",
  "THE POCHAMPALLY CO OP URBAN BANK LTD",
  "THE PRAKASAM DIST CO OP CENTRAL BANK LTD",
  "THE PUSAD URBAN CO OP BANK LTD",
  "THE RANDER PEOPLES CO OP BANK LTD",
  "THE SAHYADRI SAHAKARI BANK LTD",
  "THE SARVODAYA CO-OP BANK LTD",
  "THE SHILLONG COOPERATIVE URBAN BANK LTD",
  "THE SHIRPUR PEOPLES CO-OP bank LTD",
  "THE SHOLAPUR DISTRICT CENTRAL CO-OP BANK",
  "THE SOLAPUR SOCIAL URBAN CO OP BANK LTC",
  "THE SURAT DISTRICT CO-OP BANK LTD",
  "THE SURATH PEOPLES COOPERATIVE BANK LTD",
  "THE TRIVANDRUM CO OP URBAN BANK LTD",
  "THE UNITED CO OP BANK LTD",
  "THE URBAN CO OP BANK LTD SAHARANPUR",
  "THE VALLABH VIDYANAGAR COMMERCIAL CO-OP",
  "THE VALSAD MAHILA NAGRIK SAHAKARI BANK L",
  "THE VELLORE DISTRICT CENTRAL CO-OP BANK",
  "THE VERAVAL PEOPLES CO-OP BANK LTD",
  "THE WASHIM URBAN CO OP BANK LTD, WASHIM",
  "TJSB",
  "TJSB SAHAKARI BANK LTD",
  "TNSC Bank",
  "TUMKUR GRAIN MERCHANTS CO-OP BANK LTD",
  "Tambaram Coop Urban Bank Ltd",
  "Tamil Nadu Industrial Coop Bank Ltd",
  "Tamilnadu Grama Bank",
  "Tamluk Ghatal Central Coop Bank Ltd",
  "Tanalur Service Coop Bank Ltd",
  "Tapi Coop Bank Ltd",
  "Tasgaon Urban Coop Bank Ltd",
  "Telangana Grameena Bank",
  "Telangana State Co-operativeApexBank ltd",
  "Tellicherry Coop Rural Bank Ltd",
  "Tellicherry Coop Town Bank Ltd",
  "Tellicherry Coop Urban Bank Ltd",
  "Textile Coop Bank Ltd",
  "Textile Coop Bank of Surat Ltd",
  "Textile Traders Coop Bank Ltd",
  "Thaikkad Service Coop Bank Ltd",
  "Thane Bharat Sahakari Bank Ltd",
  "Thane Janata Sahakari Bank",
  "Thar Aanchalik Gramin Bank",
  "The Abhinav Sahakari Bank Ltd",
  "The Adinath Co-Operative Bank Ltd",
  "The Ahmedabad Mercantile Coop Bank Ltd",
  "The Ajara Urban coop Bank Ltd",
  "The Akola District Central Co Op Bank Lt",
  "The Akola Urban Cooperative Bank Limited",
  "The Alakode Service Coop Bank Ltd",
  "The Amalner Co-Op. Urban Bank Ltd., Amal",
  "The Amravati Dist CTRL Coop Bank Ltd",
  "The Amravati Merchants Co-op Bank Ltd",
  "The Annasaheb Savant Co-op Urban Bank Ma",
  "The Ashta People's Co-operative Bank Ltd",
  "The Aurangabad Dist Central Co op Ltd",
  "The Baidyabati Sheoraphuli Co-Operative",
  "The Bailhongal Urban Coop Bank Ltd",
  "The Banaskantha Mercantile Co-op Bank Lt",
  "The Bank of Nova Scotia",
  "The Bapunagar Mahila Co-op.Bank Ltd.",
  "The Baramati Sahakari Bank Ltd",
  "The Baroda Central Co-op Bank Ltd",
  "The Bhagyodaya Coop Bank Ltd",
  "The Bharat Co-Op Bank (Mumbai) Ltd",
  "The Chennimalai Coop Urban Bank Ltd",
  "The Citizen Co-operative Bank Ltd",
  "The Co-Operative Bank of Rajkot Ltd",
  "The Co-op Bank of Rajkot Ltd",
  "The Cooperative City Bank Ltd",
  "The Devgad Urban Coop Bank Ltd",
  "The Dharmaj Peoples Co-Op Bank Ltd",
  "The Financial Co-Operative Bank Ltd.",
  "The Gayatri Co Operative Urban Bank ltd",
  "The Goa State Co. Operative Bank Ltd",
  "The Goa Urban Co. Op. Bank Ltd",
  "The Greater Bombay Co-operative Bank Ltd",
  "The Gujarat State Co Op Bank Ltd",
  "The Gujarat State co-op Bank Ltd",
  "The Harayana State Coop Apex Bank Ltd",
  "The Hasti Coop Bank Ltd",
  "The Himachal Pradesh State Coop Bank Ltd",
  "The Howrah District Central Co-Operative",
  "The Hyderabad Dist Co.Op Central Bank Lt",
  "The Income Tax Dept. Coop Bank Ltd.",
  "The J.D.C.C. BANK LTD.,",
  "The Jain Sahakari Bank Ltd",
  "The Jaipur central cooperative bank ltd",
  "The Jalgaon Peoples Coop Bank Ltd",
  "The Janalaxmi  Co-op  Bank Ltd",
  "The Kalol Nagarik Sahakari bank",
  "The Kalpetta Service Coop Bank Ltd",
  "The Kalyan Janta Sahakari Bank",
  "The Kangra Central Cooperative Bank Ltd",
  "The Kangra Co-operative Bank Ltd.",
  "The Karad Janata Sahakari Bank Ltd",
  "The Kasaragod District Co-op Bank Ltd",
  "The Khambhat Nagarik Sahakari Bank Ltd",
  "The Khamgaon Urban Coop Bank Ltd",
  "The Khattri Co-operative Urban Bank Ltd",
  "The Kodungallur Town Cooperative Bank",
  "The Konark Urban Co-Op Bank Ltd",
  "The Kranthi Coop Urban Bank Ltd",
  "The Kukarwada Nagarik Sahakari Bank Ltd",
  "The Ludhiana Central Cooperative Bank",
  "The Maharashtra State Co-op Bank Ltd",
  "The Malappuram District Co-op Bank Ltd",
  "The Mansa Nagarik Sahakari bank Ltd",
  "The Mehsana Coop Bank Ltd",
  "The Mehsana Mahila Sahakari Bank Ltd",
  "The Mehsana Nagrik Sahakari Bank Ltd",
  "The Municipal co-operative Bank Ltd",
  "The Muslim Mehdavia Coop Bank Ltd",
  "The Mysore Coop Bank Ltd",
  "The Nainital Bank Ltd",
  "The Nasik Merchant's Co-op  Bank Ltd",
  "The Nasik Merchants Co-operative Bank Lt",
  "The National Co-op Bank Ltd",
  "The Ojhar Merchants co-op Bank Ltd",
  "The Pandharpur Merchant's Co-Op Bank Ltd",
  "The Pandharpur Urban Co-op Bank",
  "The Panipat Urban Co-Op Bank Ltd",
  "The Peoples Coop Credit Society Ltd",
  "The Perakam Service Coop Bank Ltd",
  "The Pimpalgaon Merchant's Co-op Bank Ltd",
  "The Prathamik Shikshak Sahakari Bank Ltd",
  "The Rahuta Union Coop Bank Ltd",
  "The Raigad Dist Centrl Co-operative Bank",
  "The Rajasthan State Coop Bank Ltd",
  "The Rajasthan Urban Co-operative Bank Lt",
  "The Rajkot Commercial co-op Bank Ltd",
  "The Ranuj Nagarik Sahakari Bank Ltd",
  "The Royal Bank of Scotland",
  "The Sabarkantha Dist Cen Coop Bank Ltd",
  "The Salem Dist.Central Co-Operative Bank",
  "The Santragachi Coop Bank Ltd",
  "The Sardargunj Mercantile Co-Op.Bank Ltd",
  "The Sarvodaya Sahakari Bank Ltd",
  "The Shirpur Merchants Coop Bank Ltd",
  "The Sind Coop Urban Bank Ltd",
  "The Social Co-operative Bank Ltd.",
  "The South Canara Dist Central Co-Op Bank",
  "The Surat Merchantile Co-Op Bank Ltd",
  "The Surat National Co Operative Bank",
  "The Surat People's co operative Bank",
  "The Sutex Co Op Bank Ltd",
  "The Sutex Co-Op.Bank Ltd",
  "The Suvikas People's co-op Bank Ltd",
  "The Tamil Nadu State Apex Co-op Bank Ltd",
  "The Tamil Nadu State Apex Co-operative B",
  "The Texco Co-operative Bank",
  "The Thane Dist.Central Co-op.Bank Ltd",
  "The Union Co-Operative Bank Ltd",
  "The Uttarpara Co-Op Bank Ltd.",
  "The Vaish Co-operative Adarsh Bank Ltd",
  "The Vaish Co-operative New Bank Limited",
  "The Vishweshwar Sahakari Bank Limited",
  "The Vriddhachalam Coop Urban Bank Ltd",
  "The Yashwant Coop Bank Ltd",
  "The Yavatmal Urban Co-op Bank Ltd",
  "The Zoroastrian Coop Bank Ltd",
  "The vaijapur Merchant's Co- Op Bank Ltd",
  "The Sarvoday Sahakari Bank",
  "The surat District Co Operative Bank",
  "The yeola merchant cooperative bank",
  "Thiruvalluvar Town Coop Bank Ltd",
  "Thodupuzha Town Service Coop Bank Ltd",
  "Thrissur Dist Co-Op Bank Ltd",
  "Tiruchendur Coop Urban Bank Ltd",
  "Tiruchengode Coop Urban Bank",
  "Tirukoilur Coop Urban Bank Ltd",
  "Tirupati Coop Bank Ltd",
  "Tirupati Urban Co-op Bank",
  "Tirur Urban Coop Bank Ltd",
  "Town Coop Bank Ltd",
  "Trichur Urban Coop Bank Ltd",
  "Trithala Service Coop Bank Ltd",
  "Triveni Kshetriya Gramin Bank",
  "Tulsi Gramin Bank",
  "U P Coop  Bank Ltd",
  "U P Gramin Bank",
  "U P Postal Primary Coop  Bank Ltd",
  "U P Sahakari Gramin Vikas Bank Ltd",
  "UBK Gramin Banks",
  "UBKG Bank",
  "UCO Bank",
  "UFJ Bank Ltd",
  "UNA Peoples Coop Bank Ltd",
  "UNIVERSAL COOPETAIVE URBAN BANK LTD",
  "UTTARAKHAND GRAMIN BANK",
  "UTTARKASHI ZILA SAHKARI BANK LTD",
  "Udaipur Central Coop Bank",
  "Udaipur Mahila Samrudhi Urban Coop Bank",
  "Udaipur Mahila Urban Coop Bank Ltd",
  "Udaipur Urban Coop Bank Ltd",
  "Udamalpet Coop Urban Bank Ltd",
  "Udgir Urban Coop Bank Ltd",
  "Udham Singh Nagar Dist Coop Bank Ltd",
  "Udhana Citizen Coop Bank Ltd",
  "Udupi Taluk Industrial Coop Society",
  "Udupi Town Coop Bank Ltd",
  "Udyam Nagri Sahakari Bank",
  "Udyam Vikas Sahakari Bank Ltd",
  "Ujjain Nagrik Sahakari Bank",
  "Ujjivan Bank",
  "Uloor Service Coop Bank",
  "Umayanalloor Service Coop Bank Ltd",
  "Umiya Urban Co-operative Bank",
  "Umreth Urban Coop Bank Ltd",
  "Unava Nagarik Sahakari Bank",
  "Union Commercial Coop Bank Ltd",
  "United Commercial Coop Bank Ltd",
  "United Industrial Bank Ltd",
  "United Mercantile Coop Bank Ltd",
  "Unjha Nagarik Sahakari Bank Ltd",
  "Unnati Coop Bank Ltd",
  "Urakam Service Coop Bank Ltd",
  "Urban Bank",
  "Urban Co-Operative Bank Ltd,Bareilly",
  "Urban Coop Bank Ltd",
  "Urban Coop Credit Society Ltd",
  "Urukunnu Service Coop Bank Ltd",
  "Utkal Coop Banking Society Ltd",
  "Utkal Gramya Bank",
  "Utkarsh Small Finance Bank",
  "Uttar Bihar Gramin Bank",
  "Uttar Pradesh Co-Operative Bank Ltd",
  "Uttaranchal Gramin Bank",
  "Uttarbanga Kshetriya Gramin Bank",
  "Uttarsanda Peopls Coop Bank Ltd",
  "Uttranchal State Coop Bank Ltd",
  "V S V Co operative Bank Ltd",
  "VALSAD DISTRICT CENTRAL CO-OP BANK LTD.",
  "VARDHAMAN [MAHILA] CO-OP. URBAN BANK LTD",
  "VIDARBHA MERCHANTS URBAN CO-OP.BANK",
  "VIKRAMADITYA NAGRIK SAHAKARI BANK MARYAD",
  "VISL Employees Coop Bank Ltd",
  "VITA BANK",
  "VVCC",
  "Vaidyanath Urban Coop Bank Ltd",
  "Vaishali Kshetriya Gramin Bank",
  "Vaishya Nagari Sahakari Bank Ltd",
  "Vaishya Sahakari Bank Ltd",
  "Valiya Parambil Service Coop Bank Ltd",
  "Vallalar Grama Bank",
  "Vananchal Gramin Bank",
  "Vani Coop Urban Bank Ltd",
  "Varachha Coop Bank Ltd",
  "Varada Grameena Bank",
  "Varapuzha Service Coop Bank Ltd",
  "Vardhman Coop Bank Ltd",
  "Vasai Janata Sahakari Bank Ltd",
  "Vasai Janta Sahakari Bank Ltd",
  "Vasai Vikas Sahakari Bank Ltd",
  "Vasavi Coop Urban Bank Ltd",
  "Vellala Coop Bank Ltd",
  "Vellore Central Coop Bank Ltd",
  "Vellore Dist Central Coop Bank Ltd",
  "Vellore Service Coop Bank Ltd",
  "Vengeri Service Coop Bank Ltd",
  "Veraval Mercantile Coop Bank Ltd",
  "Vettikattiri Service Coop Bank",
  "Vidharbha Konkan Gramin Bank",
  "Vidharbha Kshetriya Gramin Bank",
  "Vidisha Bhopal Kshetriya Gramin Bank",
  "Vidur Gramin Bank",
  "Vidya Sahakari Bank Ltd",
  "Vidyasagar Central Coop Bank Ltd",
  "Vijay Commercial Coop Bank Ltd",
  "Vijay Coop Bank Ltd",
  "Vikas Sahakari Bank Ltd",
  "Vikas Souharda Coop Bank Ltd",
  "Vima Kamgar Coop Bank Ltd",
  "Viramgam Mercantile Coop Bank Ltd",
  "Virudhunagar Dist Central Coop Bank Ltd",
  "Visakhapatnam Coop Bank Ltd",
  "Vishwas Coop Bank Ltd",
  "Visveshvaraya Grameena Bank",
  "Vyapari Sahakari Bank Maryadit",
  "Vyavsayik Sahkari Bank Ltd",
  "Vysya Bank Ltd",
  "Vysya Coop Bank Ltd",
  "WARDHAMAN URBAN CO-OPERATIVE BANK LTD",
  "Wai Urban Coop Bank Ltd",
  "Wainganga Krishna Gramin Bank",
  "Wainganga Kshetriya Gramin Bank",
  "Warangal Urban Coop Bank Ltd",
  "Wardha Dist Central Coop Bank Ltd",
  "Wardha Nagari Sahakari Adhikosh Bank",
  "West Bengal State Coop Bank Ltd",
  "West Quilon Service Coop Bank Ltd",
  "Womens Coop Bank Ltd",
  "Yadrav Coop Bank Ltd",
  "Yavatmal Dist Central Coop Bank Ltd",
  "Youth Development Coop Bank Ltd",
  "Yugprabhav Sahakari Bank Ltd",
  "ZILA SAHAKARI BANK LTD HARIDWAR",
  "ZILA SAHKARI BANK LTD",
  "ZILA SAHKARI BANK LTD GARHWAL KOTDWAR",
];

export default otherBanksList;
